import Container from '@/components/templates/container'
import { urlForImage } from '@/sanity/lib/image'
import Image from 'next/image'
import { useEffect, useState } from 'react'
import { motion } from 'framer-motion'
import { Parallax, ParallaxProvider } from 'react-scroll-parallax'
import Video from './video'

const CoverAnimation = ({
  option,
  images,
  video,
  imagePlaceholder,
  aspectRatio,
  rowOne = '',
  rowTwo = '',
}) => {
  const [activeIndex, setActiveIndex] = useState(0)

  // looping setiap 1s
  useEffect(() => {
    const interval = setInterval(() => {
      setActiveIndex((prev) => (prev + 1) % images.length)
    }, 1000) // 1s
    return () => clearInterval(interval)
  }, [images.length])

  return (
    <ParallaxProvider>
      <Container outerClassName="pt-largeMobile lg:pt-largeDesktop">
        <div className="relative w-[200px] md:w-auto md:h-[500px] mx-auto aspect-[1/1]">
          <div className="relative h-full">
            {option === 'image' ? (
              images.map(({ image }, id) => (
                <motion.div
                  key={id}
                  className="absolute top-0 left-1/2 -translate-x-1/2 h-full"
                  style={{
                    aspectRatio: image.aspectRatio,
                  }}
                  animate={{
                    opacity: activeIndex === id ? 1 : 0,
                  }}
                  transition={{
                    duration: 0,
                  }}
                >
                  <Image
                    src={urlForImage(image).url()}
                    alt={image.alt}
                    fill
                    placeholder="blur"
                    blurDataURL={image.metadata.lqip}
                    priority
                    className="object-cover"
                  />
                </motion.div>
              ))
            ) : (
              <Video
                imagePlaceholder={imagePlaceholder}
                video={video}
                aspectRatio={aspectRatio}
              />
            )}
          </div>
          <span className="absolute top-[-20px] left-[-30px] lg:top-[30px] lg:left-[-172px] w-max uppercase text-headingMobile md:text-headingDesktop font-ttDrugsTrial text-umber">
            {rowOne}
          </span>
          <Parallax
            speed={-15}
            className="absolute bottom-[180px] right-[-45px] lg:bottom-[120px] lg:right-[-219px] w-max uppercase text-headingMobile md:text-headingDesktop font-ttDrugsTrial text-umber text-right"
          >
            {rowTwo}
          </Parallax>
        </div>
      </Container>
    </ParallaxProvider>
  )
}

export default CoverAnimation
